module.exports = __webpack_public_path__ + "fonts/ruble-42a7cf33bd31f0c717b534fc9a22801a.woff";